"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('ui/shell',["require", "exports", "text!./shell.html", "services/environmentSelectionService", "routing/mainRouter", "models/userIdentityModel", "viewModels/policyViewModel", "viewModels/deviceViewModel", "viewModels/watchListViewModel", "viewModels/operationsViewModel", "viewModels/fourFive/fourFiveViewModel", "messenger", "services/sentinelService", "services/languageService", "services/hubService", "viewModels/productViewModel", "context", "@microsoft/signalr", "knockout"], function (require, exports, templateMarkup, environmentSelection, mainRouter, userIdentityModel, policyViewModel, deviceViewModel, watchListViewModel, operationsViewModel, fourFiveViewModel, messenger, sentinelService, languageService, hubService, productViewModel, context, signalR, ko) {
    "use strict";
    /// <amd-dependency path='text!./shell.html' name='templateMarkup' />

    var Shell = function () {
        function Shell() {
            _classCallCheck(this, Shell);

            this.hasClaims = userIdentityModel.hasClaims;
            this.selected = '';
            this.isSelectorVisible = ko.pureComputed(this.computeIsSelectorVisible, this);
            this.showSelector = ko.observable(false);
            this.isTitleVisible = ko.pureComputed(this.computeIsTitleVisible, this);
            this.showTitle = ko.observable(false);
            this.title = ko.pureComputed(this.computeTitle, this);
            this.envTitle = ko.pureComputed(this.computeTitle, this);
            this.titleOverride = ko.observable('');
            this.watchCount = watchListViewModel.watchedPoliciesCount;
            this.activeVehiclesWithoutGeneration = operationsViewModel.activeVehiclesWithoutGeneration;
            this.totalOperationsCount = operationsViewModel.totalOperationsCount;
            this.environments = environmentSelection.environments;
            this.selectedEnvironment = environmentSelection.selectedEnvironment;
            this.isLanguageVisible = ko.pureComputed(this.computeHasClaim.bind(this, 'language'));
            this.languages = [{ key: 'EN', value: 'en-GB' }, { key: 'FR', value: 'fr-FR' }, { key: 'ES', value: 'es-ES' }, { key: 'IT', value: 'it-IT' }];
            this.selectedLanguage = ko.observable(this.languages.find(function (l) {
                return l.value === context.language;
            }));
            this.isProductsVisible = ko.pureComputed(this.computeIsProductsVisible, this);
            this.products = productViewModel.products;
            this.selectedProduct = productViewModel.selectedProduct;
            this.isControlsVisible = ko.observable(true);
            this.itelematixComponents = [{ name: 'home', route: 'home', claim: 'home', title: 'Home', icon: 'fa fa-home fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'home')), product: 'itelematix' }, { name: 'policies', route: 'policies', claim: 'policies', title: 'Policies', icon: 'fa fa-certificate fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'policies')), product: 'itelematix' }, { name: 'watch', route: 'watch', claim: 'watch', title: 'Watch', icon: 'fas fa-eye fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'watch')), product: 'itelematix' }, { name: 'devices', route: 'devices', claim: 'devices', title: 'Devices', icon: 'fa fa-plug fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'devices')), product: 'itelematix' }, { name: 'myAccount', route: 'myAccount', claim: 'my-account', title: 'My Account', icon: 'fa fa-user fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'my-account')), product: 'itelematix' }, { name: 'reporting', route: 'reporting', claim: 'reporting', title: 'Reports', icon: 'fa fa-archive fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'reporting')), product: 'itelematix' }, { name: 'admin', route: 'admin', claim: 'admin', title: 'Admin', icon: 'fa fa-cogs fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'admin')), product: 'itelematix' }, { name: 'operations', route: 'operations', claim: 'operations', title: 'Operations', icon: 'fa fa-cog fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'operations')), product: 'itelematix' }, { name: 'systemMonitoring', route: 'systemMonitoring', claim: 'system-monitoring', title: 'Monitoring', icon: 'fas fa-tv fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'system-monitoring')), product: 'itelematix' }, { name: 'dispatch', route: 'dispatch', claim: 'dispatch', title: 'Dispatch', icon: 'fa fa-truck fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'dispatch')), product: 'itelematix' }, { name: 'userAccounts', route: 'userAccounts', claim: 'user-accounts', title: 'User Accounts', icon: 'fa fa-users fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'user-accounts')), product: 'itelematix' }, { name: 'management', route: 'management', claim: 'management', title: 'Management', icon: 'fa fa-tachometer-alt fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'management')), product: 'itelematix' }, { name: 'imports', route: 'imports', claim: 'imports', title: 'Imports', icon: 'fa fa-save fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'imports')), product: 'itelematix' }, { name: 'developer', route: 'developer', claim: 'developer', title: 'Developer', icon: 'fa fa-terminal fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'developer')), product: 'itelematix' }];
            this.fourFiveComponents = [{ name: 'fourFiveHome', route: 'home', claim: 'four-five-home', title: 'Home', icon: 'fa fa-home fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'four-five-home')), product: 'fourfive' }, { name: 'fourFiveUsers', route: 'users', claim: 'four-five-users', title: 'Users', icon: 'fa fa-graduation-cap fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'four-five-users')), product: 'fourfive' }, { name: 'fourFiveReporting', route: 'reporting', claim: 'four-five-reports', title: 'Reports', icon: 'fa fa-archive fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'four-five-reports')), product: 'fourfive' }, { name: 'fourFiveAdmin', route: 'admin', claim: 'four-five-admin', title: 'Admin', icon: 'fa fa-cogs fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'four-five-admin')), product: 'fourfive' }, { name: 'fourFiveManagement', route: 'management', claim: 'four-five-management', title: 'Management', icon: 'fa fa-tachometer-alt fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'four-five-management')), product: 'fourfive' }, { name: 'userAccounts', route: 'userAccounts', claim: 'user-accounts', title: 'User Accounts', icon: 'fa fa-users fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'user-accounts')), product: 'fourfive' }, { name: 'fourFiveImports', route: 'imports', claim: 'four-five-imports', title: 'Imports', icon: 'fa fa-save fa-2x', hasClaim: ko.pureComputed(this.computeHasClaim.bind(this, 'four-five-imports')), product: 'fourfive' }];
            this.components = ko.pureComputed(this.computeComponents, this);
            this.selectedComponent = ko.observable();
            messenger.on('environment:show-selector', function () {
                this.showSelector(true);
            }.bind(this));
            messenger.on('environment:hide-selector', function () {
                this.showSelector(false);
            }.bind(this));
            messenger.on('environment:show-title', function () {
                this.showTitle(true);
            }.bind(this));
            messenger.on('environment:hide-title', function () {
                this.showTitle(false);
            }.bind(this));
            messenger.on('environment:set-title', function (event, title) {
                this.titleOverride(title);
            }.bind(this));
            messenger.on('identity:logout', function () {
                this.showSelector(false);
                this.showTitle(false);
                this.setComponent('home');
            }.bind(this));
            messenger.on('environment:hide-controls', function () {
                this.isControlsVisible(false);
            }.bind(this));
            messenger.on('environment:show-controls', function () {
                this.isControlsVisible(true);
            }.bind(this));
            if (userIdentityModel.isAuthenticated()) {
                environmentSelection.loadEnvironments();
            }
            if (mainRouter.router.component().split(':')[0] === 'fourFive' && !this.hasClaim('four-five')) {
                mainRouter.router.navigate('/');
            }
            this.setComponent(mainRouter.router.component());
            mainRouter.router.component.subscribe(function (component) {
                this.setComponent(component);
            }.bind(this));
            userIdentityModel.isAuthenticated.subscribe(function (isAuthenticated) {
                if (isAuthenticated) {
                    environmentSelection.loadEnvironments();
                    this.setComponent(mainRouter.router.component());
                }
            }.bind(this));
            operationsViewModel.getVehicleManagementOperationsCount();
            this.subscribeToAnalysisHub();
        }

        _createClass(Shell, [{
            key: "formatter",
            value: function formatter(time) {
                return time.substring(0, 8);
            }
        }, {
            key: "subscribeToAnalysisHub",
            value: function subscribeToAnalysisHub() {
                hubService.getHubAccess('AnalysisHub').done(function (response) {
                    this.analysisHubConnection = new signalR.HubConnectionBuilder().withUrl(response.url, { accessTokenFactory: function accessTokenFactory() {
                            return response.accessToken;
                        } }).build();
                    this.analysisHubConnection.start().then(function () {
                        this.analysisHubConnection.on("VehicleLookupRequiredTablesUpdated", function () {
                            operationsViewModel.getVehicleManagementOperationsCount();
                        });
                        this.analysisHubConnection.on("PolicyVehicleStatisticsTableUpdated", function () {
                            operationsViewModel.getVehicleManagementOperationsCount();
                        });
                    }.bind(this));
                    /*this.journeyHubConnection.hub.disconnected(function () {
                        setTimeout(function () {
                            this.journeyHubConnection.start();
                                  operationsViewModel.getVehicleManagementOperationsCount();
                              }.bind(this), 5000);
                    }.bind(this));*/
                }.bind(this));
            }
        }, {
            key: "setComponent",
            value: function setComponent(component) {
                if (userIdentityModel.isAuthenticated()) {
                    if (mainRouter.router.component().split(':')[0] === 'fourFive') {
                        if (this.hasClaim('four-five')) {
                            this.selectedProduct(this.products.find(function (p) {
                                return p.value === 'fourfive';
                            }));
                            this.selectComponent(component.split(':')[1]);
                        }
                    } else {
                        if (this.hasClaim('itelematix')) {
                            this.selectedProduct(this.products.find(function (p) {
                                return p.value === 'itelematix';
                            }));
                            this.selectComponent(component.split(':')[0]);
                        } else if (this.hasClaim('four-five')) {
                            mainRouter.router.navigate('/fourfive/');
                        }
                    }
                } else {
                    this.selectedProduct(this.products.find(function (p) {
                        return p.value === 'itelematix';
                    }));
                    this.selectComponent(component.split(':')[0]);
                }
            }
        }, {
            key: "computeComponents",
            value: function computeComponents() {
                if (userIdentityModel.isAuthenticated()) {
                    if (this.selectedProduct()) {
                        if (this.selectedProduct().value === 'itelematix' && this.hasClaim('itelematix')) {
                            return this.itelematixComponents;
                        }
                        if (this.selectedProduct().value === 'fourfive' && this.hasClaim('four-five')) {
                            return this.fourFiveComponents;
                        }
                    }
                } else {
                    return this.itelematixComponents;
                }
                return [];
            }
        }, {
            key: "computeIsProductsVisible",
            value: function computeIsProductsVisible() {
                return this.computeHasClaim('four-five') && this.computeHasClaim('itelematix');
            }
        }, {
            key: "productChanged",
            value: function productChanged() {
                if (this.selectedProduct().value === 'itelematix') {
                    mainRouter.router.navigate('/');
                } else {
                    mainRouter.router.navigate('/fourfive/');
                }
            }
        }, {
            key: "languageChanged",
            value: function languageChanged() {
                languageService.change(this.selectedLanguage().value);
            }
        }, {
            key: "computeIsSelectorVisible",
            value: function computeIsSelectorVisible() {
                var environments = environmentSelection.environments();
                return environments.length > 1 && this.showSelector();
            }
        }, {
            key: "computeIsTitleVisible",
            value: function computeIsTitleVisible() {
                return environmentSelection.selectedEnvironment() !== null && this.showTitle();
            }
        }, {
            key: "computeTitle",
            value: function computeTitle() {
                return this.titleOverride() !== '' ? this.titleOverride() : environmentSelection.selectedEnvironment() ? environmentSelection.selectedEnvironment().name : '';
            }
        }, {
            key: "computeHasClaim",
            value: function computeHasClaim(claimValue) {
                if (userIdentityModel.hasClaims() && userIdentityModel.isAuthenticated()) {
                    return this.hasClaim(claimValue);
                }
                return false;
            }
        }, {
            key: "selectComponent",
            value: function selectComponent(componentName) {
                if (!userIdentityModel.isAuthenticated()) {
                    componentName = 'home';
                }
                if (this.selectedProduct().value === 'fourfive') {
                    messenger.trigger('environment:set-title', '');
                    messenger.trigger('environment:hide-title');
                    messenger.trigger('environment:hide-selector');
                } else {
                    switch (componentName) {
                        case 'home':
                        case 'policies':
                        case 'reporting':
                        case 'imports':
                        case 'dispatch':
                        case 'developer':
                            messenger.trigger('environment:set-title', '');
                            messenger.trigger('environment:show-title');
                            messenger.trigger('environment:show-selector');
                            break;
                        case 'management':
                            messenger.trigger('environment:show-title');
                            messenger.trigger('environment:hide-selector');
                            messenger.trigger('environment:set-title', 'Management Overview');
                            break;
                        default:
                            messenger.trigger('environment:set-title', '');
                            messenger.trigger('environment:hide-title');
                            messenger.trigger('environment:hide-selector');
                    }
                }
                if (this.selectedComponent() == null || componentName !== this.selectedComponent()['name']) {
                    if (userIdentityModel.isAuthenticated()) {
                        sentinelService.logBaseTileChange(componentName);
                    }
                }
                this.selectedComponent(this.components().find(function (component) {
                    return component.name === componentName;
                }));
            }
        }, {
            key: "selectMenuItem",
            value: function selectMenuItem(menuItem) {
                switch (menuItem.name) {
                    case 'policies':
                        mainRouter.router.navigate(this.getPoliciesRoute());
                        break;
                    case 'devices':
                        mainRouter.router.navigate(this.getDevicesRoute());
                        break;
                    case 'dispatch':
                        mainRouter.router.navigate(this.getDispatchRoute());
                        break;
                    case 'reporting':
                        mainRouter.router.navigate(this.getReportingRoute());
                        break;
                    default:
                        if (this.selectedProduct().value === 'fourfive') {
                            mainRouter.router.navigate('/fourfive/' + menuItem.route);
                        } else {
                            mainRouter.router.navigate('/' + menuItem.route);
                        }
                        break;
                }
            }
        }, {
            key: "getPoliciesRoute",
            value: function getPoliciesRoute() {
                var policiesRoute = '/policies';
                if (policyViewModel.policy()) {
                    return policiesRoute + '/' + policyViewModel.environment + '/' + policyViewModel.policy().brokerPolicyId + '/' + policyViewModel.policy().id;
                }
                if (environmentSelection.selectedEnvironment()) {
                    return policiesRoute + '/' + environmentSelection.selectedEnvironment().id;
                }
                return policiesRoute;
            }
        }, {
            key: "getDevicesRoute",
            value: function getDevicesRoute() {
                var devicesRoute = '/devices';
                if (deviceViewModel.selectedDevice()) {
                    return devicesRoute + '/' + deviceViewModel.selectedDevice().boxId;
                }
                return devicesRoute;
            }
        }, {
            key: "getDispatchRoute",
            value: function getDispatchRoute() {
                var dispatchRoute = '/dispatch';
                if (environmentSelection.selectedEnvironment()) {
                    return dispatchRoute + '/' + environmentSelection.selectedEnvironment().id + '/dpd';
                }
                return dispatchRoute;
            }
        }, {
            key: "getReportingRoute",
            value: function getReportingRoute() {
                if (this.selectedProduct().value === '2') {
                    return '/fourfive/reporting';
                }
                var reportingRoute = '/reporting';
                if (environmentSelection.selectedEnvironment()) {
                    return reportingRoute + '/' + environmentSelection.selectedEnvironment().id;
                }
                return reportingRoute;
            }
        }, {
            key: "getFourFiveRoute",
            value: function getFourFiveRoute() {
                var fourFiveRoute = '/fourFive';
                if (fourFiveViewModel.fourFiveUser()) {
                    return fourFiveRoute + '/' + fourFiveViewModel.fourFiveUser().userId();
                }
                return fourFiveRoute;
            }
        }, {
            key: "hasClaim",
            value: function hasClaim(claimValue) {
                if (userIdentityModel.isAuthenticated() && userIdentityModel.claims().length > 0) {
                    if (userIdentityModel.userName() === 'adrian@flux.com') {
                        return false;
                    }
                    return userIdentityModel.claims().find(function (claim) {
                        return claim.claimType === 'auth' && claim.claimValue === claimValue;
                    }) !== undefined;
                }
            }
        }]);

        return Shell;
    }();

    return { viewModel: Shell, template: templateMarkup };
});
//# sourceMappingURL=shell.js.map;
